import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import { Stack, Typography, Theme } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { IBiometricDrawer } from './types';

export const BiometricDrawer: React.FC<IBiometricDrawer> = ({
  open,
  onClose,
  onButtonClick,
}) => {
  const { t } = useTranslation();

  const toggleDrawer =
    () => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event.type === 'keydown' &&
        ((event as React.KeyboardEvent).key === 'Tab' ||
          (event as React.KeyboardEvent).key === 'Shift')
      ) {
        return;
      }

      onClose;
    };

  const list = () => (
    <Box
      role="presentation"
      onClick={() => toggleDrawer()}
      onKeyDown={() => toggleDrawer()}
      sx={(theme: Theme) => ({
        display: 'flex',
        flexDirection: 'column',
        padding: '20px',
        background: theme.palette.gray[150],
        tabIndex: -1,
        gap: '20px',
      })}
    >
      <Typography
        align="center"
        variant="body1"
        color="green.main"
        onClick={() => toggleDrawer()}
      >
        {t('userAuth.biometricDrawer.title')}
      </Typography>
      <Stack
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, 1fr)',
          gap: '20px',
        }}
      >
        <Button variant="contained" onClick={() => onButtonClick(true)}>
          {t('userAuth.biometricDrawer.acceptButtonText')}
        </Button>
        <Button variant="text" onClick={() => onButtonClick(false)}>
          {t('userAuth.biometricDrawer.declineButtonText')}
        </Button>
      </Stack>
    </Box>
  );

  return (
    <Stack>
      <Drawer
        anchor={'bottom'}
        open={open}
        onClose={() => toggleDrawer()}
        sx={{
          '& .MuiPaper-root': {
            maxWidth: '400px',
            margin: '0 auto',
          },
        }}
        ModalProps={{
          disableAutoFocus: true,
          disableEnforceFocus: true,
          disableRestoreFocus: true,
        }}
      >
        {list()}
      </Drawer>
    </Stack>
  );
};
